import React from 'react';
import { Router } from 'react-router';
import { hot } from 'react-hot-loader/root';
import { Provider } from 'react-redux';

import App from 'layouts/App';

import { getBanner } from 'model/banner';
import {
	getHotProduct,
	getFeatureProduct,
	getCollectProduct,
	cleanCollectProduct,
} from 'model/product';
import { getNews } from 'model/news';
import { getCategory } from 'model/category';

import ProductRoute from './Product';
import SearchRoute from './Search';
import UserRoute from './User';
import CollectionRoute from './Collection';
import CartRoute from './Cart';
import AboutRoute from './About';
import ServiceRoute from './Service';

const createRoutes = store => ({
	path: '/',
	component: App,
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./Home').default;
					cb(null, component);
				},
				'Home',
			),
		onEnter: () => {
			store.dispatch(getBanner());
			store.dispatch(getHotProduct());
			store.dispatch(getFeatureProduct());
			store.dispatch(getNews());

			const {
				auth: { accessToken },
			} = store.getState();

			if (accessToken !== '') {
				store.dispatch(getCollectProduct());
			} else {
				store.dispatch(cleanCollectProduct());
			}
		},
	},
	onEnter: () => {
		store.dispatch(getCategory());
	},
	onChange: () => {
		window.scrollTo(0, 0);
	},
	childRoutes: [
		ProductRoute(store),
		SearchRoute(store),
		UserRoute(store),
		CollectionRoute(store),
		CartRoute(store),
		AboutRoute(),
		ServiceRoute(),
	],
});

const Routes = ({ store, history }) => (
	<Provider store={store}>
		<Router history={history} routes={createRoutes(store)} />
	</Provider>
);

export default hot(Routes);
